import { useMemo } from "react";
import { useQuery } from "react-query";

import { UsersService } from "~/entity/Users/api/service";

const PAGE_LIMIT = 100;

/**
 * GET /user/temporary-assignments (все страницы) → Set<DealerId> дилеров,
 * уже назначенных временно ДРУГИМ пользователям (не редактируемому).
 * Такие дилеры исключаются из селекта временного закрепления: бэк отклоняет
 * назначение («уже назначен как временный у пользователя ...»).
 * Учитываем активные и запланированные (isActive/isScheduled) — оба вида
 * конфликтуют при сохранении.
 */
export function useTemporaryAssignedDealers(userId?: number) {
  const { data } = useQuery(
    ["allTemporaryAssignments"],
    async () => {
      const first = await UsersService.GET.getTemporaryAssignmentsList({
        page: 1,
        limit: PAGE_LIMIT,
      });
      const items = [...first.data.items];
      // Дотягиваем остальные страницы (1-indexed пагинация).
      for (let page = 2; page <= first.data.totalPages; page += 1) {
        const res = await UsersService.GET.getTemporaryAssignmentsList({
          page,
          limit: PAGE_LIMIT,
        });
        items.push(...res.data.items);
      }
      return items;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      onError: (error) => {
        console.error("Ошибка загрузки временных закреплений:", error);
      },
    },
  );

  return useMemo(() => {
    const dealerIds = new Set<number>();
    (data ?? []).forEach((item) => {
      if (
        item.UserId !== userId &&
        item.DealerId != null &&
        (item.isActive || item.isScheduled)
      ) {
        dealerIds.add(item.DealerId);
      }
    });
    return dealerIds;
  }, [data, userId]);
}
